module.exports = __webpack_public_path__ + "img/select-dropdown.ae948964.svg";